export enum VisibilityOnDependFailure {
    HIDE_QUESTION = 'hideQuestion',
    DISABLE_QUESTION = 'disableQuestion'
}
